<script>
	import { onMount } from 'svelte';

	// Take in input id so it can be prerendered
	// on front page
	export let inputId;

	let value = "";
	let queriedValue = "";
	let input;
	let hasFocus = false;
	// Take -1 to mean no selection
	let selectedItem = -1;

	let modalLayer = document.getElementById('modal-layer');

	var isScrolled = false;
	function scrollToTop() {
		isScrolled = true;
		let inputPos = input.getBoundingClientRect();
		//console.log("offset", offset);
		let inputTopAbs = window.scrollY + inputPos.top;
		window.scrollTo(0, Math.round(inputTopAbs - 100));
	}

	onMount(() => {
		input = document.getElementById(inputId);
		input.oninput = function(e) {
			if (e.target.value !== value) {
				value = e.target.value;
			}
			hasFocus = true;
		};
		window.addEventListener('click', function(e) {
			if (e.target === input) {
				return;
			}
			var current = e.target;
			while (current) {
				if (current.id === 'brygga-search-container') {
					return;
				}
				current = current.parentNode;
			}
			if (hasFocus) {
				hasFocus = false;
			}
		});
		//input.addEventListener("blur", e => hasFocus = false);
		input.addEventListener("focus", e => {
			hasFocus = true;
			e.stopPropagation();
		});
		window.addEventListener('keydown', function(e) {
			if (hasFocus) {
				if (event.keyCode == 40) {
					if (selectedItem < items.length - 1) {
						selectedItem++;
					}
				} else if (event.keyCode == 38) {
					if (selectedItem > 0) {
						selectedItem--;
					}
				} else if (event.keyCode == 13) {
					if (items.length > 0 && selectedItem < items.length) {
						gotoItem(selectedItem);
					}
				}
			}
		});
		// If we see a value in the input, assume the used hit
		// back, and offer search result
		if (input.value != "") {
			value = input.value;
			hasFocus = true;
			input.focus();
		}
	});
	$: {
		if (hasFocus) {
			if (modalLayer) {
				modalLayer.classList.add('modal-layer-active');
			}
		} else {
			if (modalLayer) {
				modalLayer.classList.remove('modal-layer-active');
			}
		}
	};

	let items = [];
	$: {
		let tValue = value.trim();
		if (tValue == "") {
			if (items.length > 0) {
				items = [];
			}
		} else if (tValue.length > 1 && tValue !== queriedValue && hasFocus) {
			queriedValue = tValue;
			fetch('https://www.bryggaitonsberg.no/search?s=' + encodeURIComponent(tValue))
				.then(res => res.json())
				.then(data => {
					items = data.items;
					if (items.length == 0) {
						selectedItem = -1;
					} else {
						/*
						if (!isScrolled) {
							scrollToTop();
						}*/
						// Maybe improvement to keep selection in some case?
						selectedItem = 0;
					}
				});
		}
	};
	function gotoItem(idx) {
		if (idx < items.length) {
			window.navigateTo(items[idx].MenuItem.url, null);
		}
	}
	function transitionIn(node, {
		delay = 0,
		duration = 80
	}) {
		return {
			delay,
			duration,
			css: t => `
				transform: scaleY(${0.8 + (0.2 * t)});
				opacity: ${0.7 + (0.3 * t)};
			`
		}
	}
	function transitionOut(node, {
		delay = 0,
		duration = 80
	}) {
		return {
			delay,
			duration,
			css: t => `
				transform: scaleY(${1.0 - (0.2 * t)});
				opacity: ${1.0 - (0.3 * t)};
			`
		}
	}
</script>

<style>
	.result-items {
		/*border: 0.07rem solid #ccc;*/
		position: absolute;
		top: 100%;
		left: 0;
		width: 100%;
		border-bottom-left-radius: 0.31rem;
		border-bottom-right-radius: 0.31rem;
		transform-origin: top center;
	}
	@media only screen and (max-width: 550px) {
		/* Smaller size on mobile */
		.result-items {
			font-size: 12px;
		}
	}
	.result-item {
		border-bottom: 0.07rem solid #f5f3f3;
		padding: 0.69rem;
		background-color: #fff;
		color: #2f2f29;
		font-family: 'Arvo',Georgia,"Times New Roman",serif;
		cursor: pointer;
	}
	.result-item:hover {
		background-color: #c8ced6;
	}
	.selected {
		background-color: #e8f3ff;
	}
	.result-item:last-child {
		margin-bottom: -0.07rem;
		border-bottom-left-radius: 0.31rem;
		border-bottom-right-radius: 0.31rem;
	}
	.result-dish {
		color: rgb(28, 45, 78);
		font-size: 1.5em;
		padding: 0 0 0.31rem;
	}
	.result-location {
		font-size: 70%;
		vertical-align: 30%;
		color: rgb(36, 73, 146);
	}
	.result-category {
		color: #3f3f4b;
		font-size: 107%;
	}

</style>

{#if items.length > 0 && hasFocus}
<div class="result-items" in:transitionIn={{duration:120}}>
	{#each items as item, i}
		<div class="result-item {i == selectedItem ? 'selected' : ''}" on:click={() => gotoItem(i)}>
			<span class="result-category">{item.MenuItem.category}</span>
			<h2 class="result-dish">
				{item.MenuItem.dish}
				<span class="result-location">{item.MenuItem.location}</span>
			</h2>
			{item.MenuItem.description}
		</div>
	{/each}
</div>
{/if}